import logo from '../../assets/BCM-Logo.svg';

const Hero = () => {
  return (
    <div className="hero">
      <div className="content">
        <img src={logo} alt="Borrelli Capital Management" />
      </div>
    </div>
  )
}

export default Hero;
